<template>
  <div class="streaming-cluster-create">
    <b-form-group
      :label="$t('forms.streaming.dcNode')"
      :state="validateState('dcNode')"
      v-if="this.selectedItem == ''"
    >
      <multiselect
        v-model="form.dcNode"
        :options="dcNodeList"
        track-by="id"
        label="name"
        :loading="loadingDcNode"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.streaming.dcNode')"
        :show-no-results="false"
      />
    </b-form-group>

    <b-form-group
      :label="$t('forms.streaming.domain')"
      :state="validateState('domain')"
      v-if="this.selectedItem == ''"
    >
      <multiselect
        v-model="form.domain"
        :options="domainList"
        track-by="id"
        label="name"
        :loading="loadingDomain"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.streaming.domain')"
        :show-no-results="false"
      />
    </b-form-group>

    <Input
      label="forms.streaming.clusterName"
      id="name"
      v-model="form.name"
      :defaultValue="selectedItem.name"
      :state="validateState('name')"
    />

    <b-form-group
      :label="$t('forms.streaming.serviceType')"
      :state="validateState('service_type')"
    >
      <multiselect
        v-model="form.service_type"
        :options="serviceTypeList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.streaming.serviceType')"
        :show-no-results="false"
      />
    </b-form-group>

    <Input
      label="forms.streaming.description"
      id="description"
      v-model="form.description"
      :defaultValue="selectedItem.description"
      :state="validateState('description')"
    />

    <!-- :defaultValue="name" -->
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'CreateStreamingCluster',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedItem: String | Object,
  },
  data() {
    return {
      form: {
        dcNode: '',
        domain: '',
        name: '',
        service_type: '',
        description: '',
      },
      dcNodeList: [],
      domainList: [],
      loadingDcNode: false,
      loadingDomain: false,
      serviceTypeList: [
        { id: 'rtmp', name: 'RTMP' },
        { id: 'vod', name: 'VOD' },
        { id: 'webrtc', name: 'WEBRTC' },
      ],
    }
  },
  validations: {
    form: {
      dcNode: {
        required: requiredIf(function () {
          return this.selectedItem == ''
        }),
      },
      domain: {
        required: requiredIf(function () {
          return this.selectedItem == ''
        }),
      },
      name: {
        required,
      },
      service_type: {
        required,
      },
      description: {
        required,
      },
    },
  },
  created() {
    this.getDatacenterNodes()
    this.getDomains()
  },
  methods: {
    // datacenter node::begin
    getDatacenterNodes() {
      this.getDatacenterNodeList()
        .then((res) => {
          this.setDatacenterNodeList(res)
        })
        .catch(() => {
          this.dcNodeList = []
        })
    },
    getDatacenterNodeList() {
      this.loadingDcNode = true
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/datacenters?orderBy=position|ASC`)
          .then(({ data }) => {
            resolve(data)
            this.loadingDcNode = false
          })
          .catch((err) => {
            reject(err)
            this.loadingDcNode = false
          })
      })
    },
    setDatacenterNodeList(res) {
      if (res && res.data && res.data.length > 0) {
        this.dcNodeList = res.data
      }
    },
    // datacenter node::end
    // domain::begin
    getDomains() {
      this.getDomainList()
        .then((res) => {
          this.setDomainList(res)
        })
        .catch(() => {
          this.domainList = []
        })
    },
    getDomainList() {
      this.loadingDomain = true
      return new Promise((resolve, reject) => {
        ApiService.get(`domains?position=id|desc`)
          .then(({ data }) => {
            resolve(data)
            this.loadingDomain = false
          })
          .catch((err) => {
            reject(err)
            this.loadingDomain = false
          })
      })
    },
    setDomainList(res) {
      if (res && res.data && res.data.length > 0) {
        this.domainList = res.data
      }
    },
    // domain::end
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        description: this.form.description,
      }

      if (this.form.service_type && this.form.service_type.id) {
        params.service_type = this.form.service_type.id
      }

      if (this.selectedItem == '') {
        if (this.form.dcNode && this.form.dcNode.id) {
          params.datacenter_id = this.form.dcNode.id
        }

        if (this.form.domain && this.form.domain.id) {
          params.domain_id = this.form.domain.id
        }
      }

      if (this.selectedItem == '') this.insertOperation(params)
      else this.updateOperation(params)
    },
    insertOperation(params) {
      ApiService.post(`streaming/cluster`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    updateOperation(params) {
      ApiService.put(`streaming/cluster/${this.selectedItem.id}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    selectedItem(newVal) {
      this.form.dcNode = ''
      this.form.domain = ''
      this.form.service_type = ''
      this.$v.$reset()
      if (newVal && newVal.service_type) {
        this.form.service_type = {
          id: newVal.service_type,
          name: newVal.service_type.toUpperCase(),
        }
      }
    },
  },
}
</script>
